/* ----------------------------------------------
Form Steps Controller
---------------------------------------------- */

export default class TriageStepsController extends Classy {
  constructor() {
    super();
    // The current position in the progress array
    this.index = 0;
    // The actual "live" progress step IDs
    this.progress = [];
    // The cached progress (as elements)
    this.fieldsets = {};
    // All the elements as an array
    this.elements = [];
  }
  goto(identifier) {
    return new Promise((resolve, reject) => {
      // Use the identifier directly if we can, otherwise check if it's a number to use as an index in the progress array
      if (!this.fieldsets[identifier]) {
        if (typeof identifier === 'number' && this.progress[identifier]) {
          identifier = this.progress[identifier];
        }
      }

      // Check for this identifier in the fieldsets object
      if (this.fieldsets[identifier]) {
        // The goto callback
        this.callback('goto', this.fieldsets[identifier]);

        // Set the index to the index of the identifier in the progress array
        this.index = this.progress.indexOf(identifier);

        // If it's there, resolve with the fieldset
        resolve(this.fieldsets[identifier]);
      } else {
        // Otherwise, if it is not there, reject
        reject();
      }
    });
  }

  // A method to remove progress ahead of the current index
  trim() {
    // Grab all the fieldsets that come after the current index
    const itemsToRemove = this.progress.slice(this.index + 1);

    // Remove the items from the progress array, and the fieldsets object
    itemsToRemove.forEach(ID => {
      this.progress.pop();
      this.remove(ID);
    });

    // Update the elements array
    this.update();

    // Return the data
    this.callback('trim', {
      removed: itemsToRemove,
      progress: this.progress
    });
  }
  update() {
    // Empty the elements array
    this.elements = [];

    // Loop the fieldsets object and add them to the elements array
    Object.keys(this.fieldsets).forEach(ID => {
      this.elements.push(this.fieldsets[ID].element);
    });

    // Return the elements array
    this.callback('update', this.elements);
    return this.elements;
  }
  add() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // ID is required
    if (!data.id) return console.error('You must provide an ID for the fieldset.');
    // Element is required
    if (!data.element) return console.error('You must provide an element for the fieldset.');

    // Grab the ID
    const ID = data.id;

    // Add the new element to the progress array
    this.progress.push(ID);

    // Add the fieldset to the fieldsets object
    this.fieldsets[ID] = data;

    // Update the elements array
    this.update();

    // Return the added fieldset
    this.callback('add', data);
    return data;
  }
  remove(ID) {
    // Grab the element
    const data = this.fieldsets[ID];
    // Remove the fieldset from the fieldsets object
    delete this.fieldsets[ID];

    // Return the removed fieldset
    this.callback('remove', data);
    return data;
  }
  back() {
    // If we can go back, reduce the index by 1
    if (this.index > 0) {
      this.index--;

      // Go to the previous step
      this.goto(this.progress[this.index]);

      // Return the previous step
      this.callback('back', this.progress[this.index]);
    }
  }
  next() {
    // If we can go forward, increase the index by 1
    if (this.index < this.progress.length - 1) {
      this.index++;

      // Go to the next step
      this.goto(this.progress[this.index]);

      // Return the next step
      this.callback('next', this.progress[this.index]);
    }
  }
}